// const url = 'https://ancient-temple-54024.herokuapp.com'
const url = 'https://m4j5u86tq6.execute-api.us-east-1.amazonaws.com'
export default url